<template>
  <!--begin::Footer-->
  <div class="app-sidebar-footer pt-3 mb-5" id="kt_app_sidebar_footer">
    <div
      class="menu menu-column menu-rounded menu-sub-indention px-3"
      data-kt-menu="true"
    >
      <section class="mt-5 footer-section">
        <div class="menu-content mb-3">
          <span class="menu-heading fw-bold text-uppercase fs-7">
            Investment support
          </span>
        </div>
        <!-- <div class="menu-item">
          <a class="menu-link" href="#" target="_blank">
            <span class="menu-icon">
              <span class="svg-icon">
                <inline-svg
                  class="inline-svg"
                  src="media/icons/menu/using.svg"
                />
              </span>
            </span>
            <span class="menu-title">Using this dealroom</span>
            <span class="svg-icon">
              <inline-svg src="media/icons/menu/open-in-new.svg" />
            </span>
          </a>
        </div> -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            exact-active-class="active"
            to="/reasons"
          >
            <span class="menu-icon">
              <span class="svg-icon">
                <inline-svg
                  class="inline-svg"
                  src="media/platforms/gabon/icons/menu/reasons.svg"
                />
              </span>
            </span>
            <span class="menu-title">Reasons to invest in Gabon</span>
          </router-link>
        </div>
      </section>

      <section class="footer-logos">
        <img
          src="media/platforms/gabon/logos/ministry.svg"
          alt="Gabon Invest"
          style="height: 50px"
        />
        <img
          src="media/platforms/gabon/logos/gabon-invest.svg"
          alt="Gabon Invest"
          style="height: 55px"
        />
      </section>
    </div>
  </div>
  <!--end::Footer-->
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "sidebar-footer",
});
</script>

<style lang="scss" scoped>
.app-sidebar-footer {
  background: #f9fafb;
  border-radius: 16px;
  margin-left: 1px;
  margin-right: 1px;
}
.footer-section {
  padding-bottom: 15px;
}

.menu-title {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 12px;
  text-transform: uppercase;
  color: #2d75b5 !important;
}
.inline-svg {
  width: 20px;
  fill: #2d75b5;
}
.menu-heading {
  color: #2d75b5;
  padding: 0px 14px;
}
.menu-item.active {
  transition: color 0.2s ease;
  background-color: var(--kt-app-sidebar-light-menu-link-bg-color-active);
  color: var(--kt-primary);
}
.footer-logos {
  border-top: 1px solid rgba(45, 118, 182, 0.28);
  margin: 0px 20px;
  padding-top: 30px;
  padding-bottom: 10px;
  img {
    padding-bottom: 20px;
    width: 100%;
    height: auto;
  }
}
</style>
